import {
  SET_USER_SALARY_CONDITIONS,
  LOADER_USER_SALARY_CONDITIONS
} from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  }
};

const UserSalaryConditions = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_SALARY_CONDITIONS:
      return {
        ...state,
        data: action.payload
      }
    case LOADER_USER_SALARY_CONDITIONS:
      return {
        ...state,
        loading: !state.loading
      }
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UserSalaryConditions;
